import React, { useContext, useState, useEffect } from 'react'
import { refreshEventName, defaultConfigs } from '../utils/initialStates'
import { DashboardContext } from 'live/context/dashboard'
import { DashboardWidgetContext } from 'live/context/dashboard-widget'
import { checkingConfigs } from '../utils/utils'
import { get } from 'lodash'


const SpanComponentTitle = ({ span, config }: { span: string; config: any }): JSX.Element => {
    const { state, params } = useContext(DashboardContext)
    const [message, setMessage] = useState('')
    const [itemLabel, setItemLabel] = useState('')
    const OperationsPickerConfigs: OperationsPickerConfigsProps = checkingConfigs(config, defaultConfigs)
    const DashboardWidgetContextReceived = useContext(DashboardWidgetContext)

    const receiveRefreshEvent = e => {
        let details: refreshEventProps = e.detail
        let newMessage = `\nSelected item: ${details.selectedItem.label}`
        newMessage += `\nSelected timespan: ${details.selectedTimespan}`
        if (OperationsPickerConfigs.enableChecking && details.checkedItemsLabels.length > 0) {
            newMessage += `\nChecked items: `
            details.checkedItemsLabels.forEach((e, i) => {
                newMessage += e + (i === details.checkedItemsLabels.length ? ' ,' : '.')
            })
            if (details.checkedTimespans) newMessage += `\nChecked timespan: ${details.checkedTimespans}`
        }
        if (OperationsPickerConfigs.saveRunReference && details.runReference) {
            newMessage += `\nRun reference: ` + JSON.stringify(details.runReference)
        }
        setMessage(newMessage)
        setItemLabel(details.selectedItem.label)
    }

    useEffect(() => {
        document.addEventListener(refreshEventName, receiveRefreshEvent)
        return () => document.removeEventListener(refreshEventName, receiveRefreshEvent)
    }, [])

    let displayedSpan = () => {
        let res = state?.currentSpan ?? span
        if (get(DashboardWidgetContextReceived, 'state.params.spanDetached')) {
            res = get(DashboardWidgetContextReceived, 'state.params.span')
        } else if (OperationsPickerConfigs.displayItemLabel && itemLabel !== '') {
            res = itemLabel
        }
        return res
    }

    if (params.mode === 'edit') {
        return (
            <>
                <span className="btn-label label-bold">DRILLING OPERATIONS: </span>
                <span>{state?.currentSpan}</span>
            </>
        )
    } else {
        return (
            <span title={`Current span: ${state?.currentSpan}${message}`}>
                {displayedSpan()}
                {
                    //message !== '' && <HelpTip placement="top">{message}Fooo lorem ipsum</HelpTip>
                }
            </span>
        )
    }
}

export default SpanComponentTitle
